import {
  apiGET,
  coreApi_default
} from "./chunk-NB6PR3JZ.mjs";

// src/adapters/common.ts
import { EnvConfig } from "@repo/env-config";
import { langTags } from "@repo/utils";
var locale = EnvConfig.GATSBY_INTL_LOCALE;
var getCountries = async () => {
  try {
    const { data } = await coreApi_default.get("/country");
    return { ok: true, data };
  } catch (error) {
    const apiError = error;
    return { ok: false, error: apiError.response?.data };
  }
};
var getCurrencies = async () => {
  try {
    const { data } = await coreApi_default.get("/currency");
    return { ok: true, data };
  } catch (error) {
    const apiError = error;
    return { ok: false, error: apiError.response?.data };
  }
};
var getNationalities = async () => {
  const params = {
    language_code: langTags[locale]?.toLowerCase()
  };
  return apiGET("/country-gentilic", { params });
};
var getLanguages = async () => apiGET("/language");
var getRegisterCountries = async () => {
  try {
    const {
      data: { data }
    } = await coreApi_default.get("/country/register");
    return { ok: true, data };
  } catch (error) {
    const apiError = error;
    return { ok: false, error: apiError.response?.data };
  }
};
var getBrazilianBanks = async () => {
  try {
    const { data } = await coreApi_default.get("/banks");
    return { ok: true, data };
  } catch (error) {
    const apiError = error;
    return { ok: false, error: apiError.response?.data };
  }
};
var getRegistrationDropdownCountries = async () => {
  try {
    const {
      data: { data }
    } = await coreApi_default.get("/country/registration-dropdown");
    return { ok: true, data };
  } catch (error) {
    const apiError = error;
    return { ok: false, error: apiError.response?.data };
  }
};
var getCountryRegions = async (countryId) => {
  return apiGET(`/country/${countryId}/regions`);
};
var getCountryCities = async (country_id) => {
  const params = { country_id };
  return apiGET("/city", { params });
};

export {
  getCountries,
  getCurrencies,
  getNationalities,
  getLanguages,
  getRegisterCountries,
  getBrazilianBanks,
  getRegistrationDropdownCountries,
  getCountryRegions,
  getCountryCities
};
